export default __webpack_public_path__ + "static/media/076-envelope.d5d661ed.svg";